import { Accordion, AccordionSummary, Checkbox, Grid } from "@material-ui/core";
import { PERMISSION_TYPE } from "common";
import React from "react";
import { useTranslation } from "react-i18next";
import { CommonDelegatePermissionTable } from "common/interfaces";
import { toUpper } from "lodash";

const CommonEditLocationPermissionTable = (props: CommonDelegatePermissionTable) => {

    const { permission_usageRate, manageSelectAll, handleDefaultSelectAll, disableSelectAllRow, handleCheckBoxColor } = props;
    const { t } = useTranslation();

    return (
        <>
            <div className="accordian_table">
                <div className={"section_title mb mt-20"}>
                    <Grid container spacing={0}>
                        <Grid item xs={2}>
                            <h2 className="text-gapping">{toUpper(t("hostsetting.assign"))}</h2>
                        </Grid>
                        <Grid item xs={3}></Grid>
                        <Grid item xs={2}>
                            <h2>{toUpper(t("common.location.information"))}</h2>
                        </Grid>
                        {permission_usageRate &&
                            <Grid item xs={1}>
                                <h2>{toUpper(t("common.usagerate"))}</h2>
                            </Grid>}
                        <Grid item xs={1}>
                            <h2>{toUpper(t("delegate.permission.fleet"))}</h2>
                        </Grid>
                        <Grid item xs={1}>
                            <h2>{toUpper(t("delegate.permission.lcd"))}</h2>
                        </Grid>
                        <Grid item xs={1}>
                            <h2>{toUpper(t("common.report"))}</h2>
                        </Grid>
                    </Grid>
                </div>

                <Accordion className="">
                    <AccordionSummary
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <div className="section_group" onClick={(event) => event.stopPropagation()}>
                            <Grid container spacing={0}>
                                <Grid item xs={2}>
                                    <div className="defult_form accordian_check text-gapping">
                                        <div className="form_col checkbox">
                                            <Checkbox
                                                id={`selectAll_LocationAccess`}
                                                checked={handleDefaultSelectAll("locationAccess")}
                                                color={'primary'}
                                                onChange={(e: any) => manageSelectAll(e, PERMISSION_TYPE.LOCATION, false)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={3}></Grid>
                                <Grid item xs={2}>
                                    <div className="defult_form accordian_check">
                                        <div className="form_col checkbox">
                                            <Checkbox
                                                id={`selectAll_LocationInfo`}
                                                checked={handleDefaultSelectAll(PERMISSION_TYPE.LOCATION_INFO, true, "locationLevelPermissions")}
                                                disabled={disableSelectAllRow}
                                                color={handleCheckBoxColor()}
                                                onChange={(e: any) => manageSelectAll(e, PERMISSION_TYPE.LOCATION_INFO, false)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                {permission_usageRate &&
                                    <Grid item xs={1}>
                                        <div className="defult_form accordian_check">
                                            <div className="form_col checkbox">
                                                <Checkbox
                                                    id={`selectAll_usageRate`}
                                                    checked={handleDefaultSelectAll(PERMISSION_TYPE.USAGE_RATE, true, "locationLevelPermissions")}
                                                    disabled={disableSelectAllRow}
                                                    color={handleCheckBoxColor()}
                                                    onChange={(e: any) => manageSelectAll(e, PERMISSION_TYPE.USAGE_RATE, false)}
                                                />
                                            </div>
                                        </div>
                                    </Grid>
                                }
                                <Grid item xs={1}>
                                    <div className="defult_form accordian_check">
                                        <div className="form_col checkbox">
                                            <Checkbox
                                                id={`selectAll_manageFleet`}
                                                checked={handleDefaultSelectAll(PERMISSION_TYPE.MANAGE_FLEET, true, "locationLevelPermissions")}
                                                disabled={disableSelectAllRow}
                                                color={handleCheckBoxColor()}
                                                onChange={(e: any) => manageSelectAll(e, PERMISSION_TYPE.MANAGE_FLEET, false)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={1}>
                                    <div className="defult_form accordian_check">
                                        <div className="form_col checkbox">
                                            <Checkbox
                                                id={`selectAll_lcdDisplay`}
                                                checked={handleDefaultSelectAll(PERMISSION_TYPE.LCD_DISPLAY, true, "locationLevelPermissions")}
                                                disabled={disableSelectAllRow}
                                                color={handleCheckBoxColor()}
                                                onChange={(e: any) => manageSelectAll(e, PERMISSION_TYPE.LCD_DISPLAY, false)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                                <Grid item xs={1}>
                                    <div className="defult_form accordian_check">
                                        <div className="form_col checkbox">
                                            <Checkbox
                                                id={`selectAll_report`}
                                                checked={handleDefaultSelectAll(PERMISSION_TYPE.REPORT, false, "locationLevelReportPermissions", true)}
                                                disabled={disableSelectAllRow}
                                                color={handleCheckBoxColor()}
                                                onChange={(e: any) => manageSelectAll(e, PERMISSION_TYPE.REPORT, true)}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </AccordionSummary>
                </Accordion>
            </div>
        </>)
}

export default CommonEditLocationPermissionTable;